module.exports = __webpack_public_path__ + "img/nested.c948fb38.svg";